<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect></BaseFacilitySelect>
    </div>
    <div class="card">
      <div class="card-header">
        <strong>RespSafe registration</strong>
      </div>
      <div class="card-body">
        <div>
          <p>
            Click below to register your organization’s intent to participate in the {{this.respiratorySeason}} <a href="https://www.health.state.mn.us/diseases/respiratory/hcp/respsafe.html"><u>RespSafe</u></a> program.<br>
            Organizations must submit the registration form before they can access the ‘Submit RespSafe report’ screen.
          </p>
          <p>
            Registration must be completed by January 31, {{this.endingYear}}.
          </p>
        </div>
        <br>
        <div>
          <b-button class="d-block p-2 bg-mdh text-white" @click="checkRegistration">
            Register intent to participate<br> in RespSafe
          </b-button>
        </div>
      </div>
      <div>
        <b-modal id="duplicate-registration-modal" hide-header hide-footer>
          <h2>RespSafe facility enrollment duplication warning</h2>
          <hr/>
          <p>This facility was registered to participate in RespSafe on {{this.registrationDate}}.<br></p>
          <p>Questions about the RespSafe program should be sent to <a href="mailto:Health.RespSafe@state.mn.us"><u>Health.RespSafe@state.mn.us</u></a>.</p>
          <p>Questions about the VaxCheck application should be sent to the VaxCheck team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.</p>
          <div>
            <b-button @click="closeDuplicateModal" style="margin-right:15px;">Back to enrollment page</b-button>
          </div>
        </b-modal>
      </div>
    </div>
  </b-container>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import router from "@/router";

axiosRetry(axios, {retries: 3, retryDelay: axiosRetry.exponentialDelay})

export default {
  components: {BaseFacilitySelect},
  data: () => ({
    org: '',
    facility: '',
    isDuplicate: false,
    registrationDate: new Date(),
    currentDate: new Date(),
    startingYear: '',
    endingYear: '',
    respiratorySeason: ''
  }),

  mounted() {
    this.handleRespiratorySeason()
  },

  methods: {
    pushContactInfoPage() {
      router.push("respSafeContact")
    },
    pushToastError() {
      this.showRootToast('Error','Please select a facility to register.','danger')
    },
    pushDuplicateModal() {
      this.$bvModal.show('duplicate-registration-modal')
    },
    closeDuplicateModal() {
      this.$bvModal.hide('duplicate-registration-modal')
    },

    handleRespiratorySeason() {
      let startingYear = ''
      let endingYear = ''

      let currUTCYear = new Date(new Date().toUTCString()).toISOString().split('-')[0]
      let currUTCMonth = new Date(new Date().toUTCString()).toISOString().split('-')[1]

      if (currUTCMonth >= 7) {
        startingYear = currUTCYear
        endingYear = parseInt(currUTCYear) + 1
      } else {
        startingYear = parseInt(currUTCYear) - 1
        endingYear = currUTCYear
      }

      this.startingYear = startingYear.toString()
      this.endingYear = endingYear.toString()
      this.respiratorySeason = startingYear.toString() + '-' + endingYear.toString()
    },

    checkRegistration() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/org`).then(response => {
        this.org = response.data
        if(this.org !== null && this.$store.state.selectedFacility) {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/respsafe/registration/${this.$store.state.selectedFacility.id}`)
            .then(response => {
              if (!(response.data.length === 0)) {
                if (response.data[0].id !== null && response.data[0].respiratorySeason === this.respiratorySeason) {
                  this.isDuplicate = true
                  this.registrationDate = this.formatDate(response.data[0].registrationDate)
                  this.pushDuplicateModal()
                } else {
                  this.pushContactInfoPage()
                }
              } else {
                this.pushContactInfoPage()
              }
            })
        } else {
          this.pushToastError()
        }
      })
    },

    formatDate(datetimeString) {
      const date = new Date(datetimeString)
      const options = {year: 'numeric', month: 'long', day: 'numeric'}

      return date.toLocaleDateString('en-US', options)
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  }
}
</script>

<style scoped>
.landing-btn {
  background-color: rgb(0, 56, 101);
  width: 10em;
}
</style>
